import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const featured = articles.slice(0, 3);

export default function FeaturedArticles() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <p className="font-heading text-accent-500 text-sm tracking-[0.2em] uppercase mb-3 whitespace-nowrap">
            Featured Articles
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            精选<span className="text-primary-600">文章</span>
          </h2>
          <p className="text-foreground-600 text-sm max-w-lg mx-auto leading-relaxed">
            深入探索时尚与自我的关系，每一篇文章都是一次灵魂的对话。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/articles/${article.slug}`}
              className="group block bg-background-100 rounded-lg overflow-hidden transition-all duration-300"
            >
              <div className="relative h-52 overflow-hidden">
                <div className="absolute inset-0 w-full h-full">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    title={`${article.title} - 裙子下面是野兽`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                  <span>{article.author}</span>
                  <span>·</span>
                  <span>{article.date}</span>
                  <span>·</span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex flex-wrap gap-2 mt-3">
                  {article.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 bg-background-200 text-foreground-600 text-xs rounded whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/articles"
            className="inline-flex items-center gap-2 text-primary-600 font-medium text-sm hover:text-primary-700 transition-colors duration-200 whitespace-nowrap"
          >
            阅读全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}